import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, Confirm, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { deleteCollection } from 'services/collection-service';
import CollectionForm from './forms/collection-form';
import { getTableParams } from './grid.params';

export const CollectionGrid = (props) => {
  const { count, entries, className, theme, updateEntry, refresh } = props;
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);
  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  const delItemAction = (row) => {
    setRow(row);
    setConfirm({
      title: 'Удалить инкассатора ' + row.name + '?',
      width: '440px',
      type: 'danger',
      cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
      acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id), theme: themes.red },
    });
  };

  /**
   * delete item
   */
  const delItem = (id) => {
    deleteCollection(id).then(() => {
      refresh(true);
      closeConfirm();
    });
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('collection.update');
  const rightAdd = user.haveRight('collection.add');
  // const rightDel = user.haveRight('collection.delete');
  const actions = [];
  // if (rightDel) {
  //   actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  // }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }

  const initial = showForm === 'addForm' ? { is_active: true } : { id: row.id, name: row.name, is_active: row.is_active, card_id: row.card_id };
  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('collection', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Инкассаторы')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
        updateEntry={updateEntry}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && <CollectionForm type={showForm} close={() => setShowForm('')} refresh={props.refresh} initialValues={initial} />}
    </GridBox>
  );
};
